export default __webpack_public_path__ + "static/media/pause-demo.095b3ca7.svg";